import { SEARCH_SEARCH_SERIES_SET_DATA } from 'rebook/apps/search/constants';


const initialState = {
  seriesList: null,
  seriesCount: null,
  query: null,
  pageNumber: 1,
  lastPageNumber: 1,
  isLoading: true,
};

export default function searchSeries(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SEARCH_SERIES_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
